<si-form-item
    [label]="label() | translate"
    [required]="required()"
    [formErrorMapper]="{ required: errorMessage() | translate }"
>
    @if (multi()) {
        <si-select
            multi
            hasFilter
            closeOnScroll
            class="form-control"
            [placeholder]="placeholder() | translate"
            [options]="displayOptions()"
            [formControl]="control()"
            [readonly]="readonly()"
        />
    } @else {
        <si-select
            hasFilter
            closeOnScroll
            class="form-control"
            [placeholder]="placeholder() | translate"
            [options]="displayOptions()"
            [formControl]="control()"
            [readonly]="readonly()"
        />
    }
</si-form-item>
